import { Components, Theme } from '@mui/material'

export const MuiLink: Components<Omit<Theme, 'components'>>['MuiLink'] = {
  defaultProps: {
    underline: 'hover',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.futureTheme.text.link,
      textDecorationColor: theme.palette.futureTheme.border.brand.strong,
    }),
  },
}
